import { EmployeeType } from '../employee/employee.types';
import { POSDataResponse } from './restaurant.types';

export interface CoinsCountType {
  [key: string]: number;
}

export interface AdjustStartingBalanceRequestType {
  operatorId: string;
  posId: number | null;
  startingBalance: string;
  comment?: string | null;
}

export interface PatchCashDrawerRequestType {
  startingBalance: string;
  comment?: string | null;
}

export interface CashDrawerType {
  id: number;
  startingBalance: number;
  currentBalance: number;
  lastExpectedCash: number | null;
  state: CashDrawerState;
  comment?: string | null;
  isHouseDrawer: boolean;
  logs?: CashDrawerLogsType[];
  pos?: POSDataResponse;
  operator?: EmployeeType;
}

export interface CashDrawerResponseType {
  data: CashDrawerType;
  success: boolean;
  message: string;
  error?: string | null;
}

export interface CloseCashDrawerType {
  operatorId: string;
  posId: number;
  coinsAndCashCount: CoinsCountType;
  closingBalance: string;
}

export interface CashDrawerLogsRequestType {
  type: LogType;
  subType?: LogSubtype | null;
  server?: string | null;
  operatorId?: string;
  posId: number;
  amount?: string | null;
  reason?: string | null;
  comment?: string | null;
}

export interface CashPaymentLogsRequestType {
  type: LogType;
  subtype?: LogSubtype;
  operatorId: string;
  amount: string;
  posId: number;
}

export interface CashDrawerLogsType {
  id: number;
  logType: LogType;
  logSubType?: LogSubtype | null;
  coinsAndCashCount?: CoinsCountType | null;
  reason?: string | null;
  comment?: string | null;
  status?: string | null;
  amount?: number | null;
  currentBalance: number;
  server?: EmployeeType | null;
  operator?: EmployeeType | null;
}

export enum LogType {
  AdjustStartingBalance = 'adjust_starting_balance',
  CashIn = 'cash_in',
  CashOut = 'cash_out',
  NoSale = 'no_sale',
  CloseDrawer = 'close_drawer',
  OpenDrawer = 'open_drawer',
  CashPayment = 'cash_payment',
  CashRefund = 'cash_refund',
  DeclareCash = 'declared_cash',
  DeclareTips = 'declared_tips',
  TransferedToHouseDrawer = 'transfered_to_house_drawer',
  CheckoutSettlement = 'checkout_settlement',
}

export enum LogSubtype {
  CashIn = 'cash_in',
  TipsCollected = 'tips_collected',
  ChangeBack = 'change_back',
  CashOut = 'cash_out',
  TipsPaid = 'tips_paid',
  PayOut = 'pay_out',
  CashPayment = 'cash_payment',
  CashRefund = 'cash_refund',
  TransferedToCashDrawer = 'transfer_to_cash_drawer',
  TransferredFromHouseDrawer = 'transferred_from_house_drawer',
  bankCashDeposit = 'bank_cash_deposit',
}

export enum SettlementType {
  YouOwe = 'youOwe',
  RestaurantOwe = 'restaurantOwe',
}

export enum CashDrawerState {
  Open = 'open',
  Closed = 'closed',
}

export enum CashDrawerLogsOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum LogReason {
  DrawerReplenishment = 'drawer_replenishment',
  TemporarayStorage = 'temporary_storage',
  DrawerFull = 'drawer_full',
  NeededElsewhere = 'needed_elsewhere',
  MovingToOffice = 'moving_to_office',
  Ingredients = 'ingredients',
  Entertainment = 'entertainment',
  MakeChange = 'make_change',
  DrawerCount = 'drawer_count',
  CashPayment = 'cash_payment',
  CashRefund = 'cash_refund',
  SalesCashDeclaration = 'sales_cash_declaration',
  Other = 'other',
  BankCashDeposit = 'bank_cash_deposit',
  TransferToCashDrawer = 'transfer_to_cash_drawer',
  TipOut = 'tip_out',
  PayOut = 'pay_out',
}
